export default "__VITE_ASSET__CEgMENeB__"